import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-between h-14" }
const _hoisted_2 = { class: "w-full text-center pt-2 pb-1 border-r border-white bg-mentalnc text-gray-700 hover:bg-mentalncLight" }
const _hoisted_3 = { class: "w-full text-center pt-2 pb-1 border-x border-white bg-mentalnc text-gray-700 hover:bg-mentalncLight" }
const _hoisted_4 = { class: "w-full text-center pt-2 pb-1 border-l border-white bg-mentalnc text-gray-700 hover:bg-mentalncLight" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_icon_text = _resolveComponent("base-icon-text")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, { to: "/account" }, {
        default: _withCtx(() => [
          _createVNode(_component_base_icon_text, {
            path: _ctx.mdiAccount,
            text: "マイページ"
          }, null, 8, ["path"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_router_link, { to: "/course" }, {
        default: _withCtx(() => [
          _createVNode(_component_base_icon_text, {
            path: _ctx.mdiBookOpenPageVariant,
            text: _ctx.t('course.title')
          }, null, 8, ["path", "text"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_router_link, { to: "/seminar" }, {
        default: _withCtx(() => [
          _createVNode(_component_base_icon_text, {
            path: _ctx.mdiCalendarCheck,
            text: "セミナー"
          }, null, 8, ["path"])
        ]),
        _: 1
      })
    ])
  ]))
}